import { c as _c } from "react/compiler-runtime";
import React from 'react';
export const AdvancedFilterIcon = React.forwardRef<SVGSVGElement>((props, ref) => {
  const $ = _c(6);
  let t0;
  let t1;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <line x1="4" y1="7.5" x2="20" y2="7.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />;
    t1 = <line x1="6" y1="12" x2="18" y2="12" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />;
    t2 = <line x1="9" y1="16.5" x2="15" y2="16.5" stroke="currentColor" strokeWidth="2" strokeLinecap="round" />;
    $[0] = t0;
    $[1] = t1;
    $[2] = t2;
  } else {
    t0 = $[0];
    t1 = $[1];
    t2 = $[2];
  }
  let t3;
  if ($[3] !== props || $[4] !== ref) {
    t3 = <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" {...props} ref={ref}>{t0}{t1}{t2}</svg>;
    $[3] = props;
    $[4] = ref;
    $[5] = t3;
  } else {
    t3 = $[5];
  }
  return t3;
});
export default AdvancedFilterIcon;